import {combineReducers} from "redux";

import LogsReducer from './logs/logs.tools.reducer';
import SystemReducer from './system/system.tools.reducer';

export default combineReducers({
  logs: LogsReducer,
  system: SystemReducer
});